import '../vendor/bootstrap.scss'
import './index.scss'
import $ from 'jquery'
import '../vendor/bootstrap'
import { setUpAuthModals } from '../components/auth-modals'
import { setUpHeaderButtons } from '../components/header'
import { setUpFooter } from '../components/footer'
import { setUpAprendaBanner } from '../components/banner'
import { populateProgress } from './elearning-progresses'

function formatDuration(durationString) {
  const re = /(h)|(\s?min(utos)?\.?)/gi
  const matches = durationString.match(re)
  if (!matches || !durationString) {
    return durationString + ' mins'
  }
  if (matches.includes('h')) {
    return durationString
  }
  return durationString.replace(re, '') + ' mins'
}

function updateCourseDuration() {
  $('.course-duration').each(function (i, item) {
    const durationString = $(item).data('duration').toString()
    const formattedText = formatDuration(durationString)
    $(item).text(formattedText)
  })
}

$(document).ready(function () {
  setUpHeaderButtons()
  updateCourseDuration()
  setUpAuthModals()
  setUpFooter()
  setUpAprendaBanner()
  populateProgress()
})
